module.exports = __webpack_public_path__ + "img/20.bbcafe5f.jpg";